import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiBox, FiBriefcase, FiLayers, FiMaximize } from 'react-icons/fi';

export default function Overview() {
  const features = [
    { 
      icon: FiBox, 
      title: '3 Industriehallen', 
      desc: 'Modern & hochbelastbar' 
    },
    { 
      icon: FiLayers, 
      title: 'Lagerhallen', 
      desc: 'Perfekte Logistik-Schnitte' 
    },
    { 
      icon: FiBriefcase, 
      title: 'Büro & Ausstellung', 
      desc: 'Repräsentative Flächen' 
    },
    { 
      icon: FiMaximize, 
      title: 'Freiflächen', 
      desc: 'Großzügig & befahrbar' 
    },
  ];

  return (
    <section id="uebersicht" className="py-24 bg-white">
      <div className="container px-4 mx-auto md:px-8">
        <div className="flex flex-col items-center mb-16 text-center">
          <h2 className="section-title">Alles an einem Ort</h2>
          <p className="section-subtitle">
            Unser Gelände bietet einen idealen Mix aus funktionalen Hallen und repräsentativen Büroflächen. 
            Perfekt abgestimmt auf produzierendes Gewerbe, Logistik und Dienstleistung.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-8 transition-shadow border border-gray-100 rounded-sm bg-gray-50 hover:shadow-lg hover:border-yellow-200 group flex flex-col items-center text-center"
            >
              <div className="flex items-center justify-center w-16 h-16 mb-6 transition-colors bg-white rounded-sm shadow-sm text-emerald-900 group-hover:bg-emerald-900 group-hover:text-yellow-500">
                <SafeIcon icon={feature.icon} className="text-2xl" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-gray-900">{feature.title}</h3>
              <p className="text-gray-600">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}